module.exports = __webpack_public_path__ + "static/media/avatar.6d564873.png";